import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=a25d400a&scoped=true"
import script from "./banner.vue?vue&type=script&lang=ts"
export * from "./banner.vue?vue&type=script&lang=ts"
import style0 from "./banner.vue?vue&type=style&index=0&id=a25d400a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25d400a",
  null
  
)

export default component.exports